import { createContext, useContext } from 'react';

export const OriginalsAccessContext = createContext(null);
export const useOriginalsAccess = () => useContext(OriginalsAccessContext);